import { Navigate, Outlet, useLocation } from 'react-router-dom';
import CookieConsent from '../../shared/components/common/CookieConsent';
import useAuth from '../../shared/hooks/useAuth';

const PublicRoute = () => {
  const { authenticated } = useAuth();
  const { search } = useLocation();

  if (!authenticated) {
    return (
      <>
        <Outlet />
        <CookieConsent />
      </>
    );
  }

  const params = new URLSearchParams(search);
  const redirectUrl = params.get('redirectUrl');
  const destination = redirectUrl || '/';

  return <Navigate to={destination} replace />;
};

export default PublicRoute;